@file:OptIn(InternalResourceApi::class)

package com.hyperether.goodjob.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.hyperether.goodjob.resources/"

public val Res.drawable.admin_svgrepo_com_1: DrawableResource by lazy {
      DrawableResource("drawable:admin_svgrepo_com_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/admin_svgrepo_com_1.xml", -1, -1),
      ))
    }

public val Res.drawable.app_logo: DrawableResource by lazy {
      DrawableResource("drawable:app_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_logo.xml", -1, -1),
      ))
    }

public val Res.drawable.apple: DrawableResource by lazy {
      DrawableResource("drawable:apple", setOf(
        ResourceItem(setOf(), "${MD}drawable/apple.xml", -1, -1),
      ))
    }

public val Res.drawable.avatar_female: DrawableResource by lazy {
      DrawableResource("drawable:avatar_female", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_female.png", -1, -1),
      ))
    }

public val Res.drawable.avatar_male: DrawableResource by lazy {
      DrawableResource("drawable:avatar_male", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_male.png", -1, -1),
      ))
    }

public val Res.drawable.back_arrow: DrawableResource by lazy {
      DrawableResource("drawable:back_arrow", setOf(
        ResourceItem(setOf(), "${MD}drawable/back_arrow.xml", -1, -1),
      ))
    }

public val Res.drawable.background_shape: DrawableResource by lazy {
      DrawableResource("drawable:background_shape", setOf(
        ResourceItem(setOf(), "${MD}drawable/background_shape.png", -1, -1),
      ))
    }

public val Res.drawable.baseline_arrow_drop_down_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_arrow_drop_down_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_arrow_drop_down_24.xml", -1, -1),
      ))
    }

public val Res.drawable.baseline_file_present_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_file_present_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_file_present_24.xml", -1, -1),
      ))
    }

public val Res.drawable.baseline_person_24: DrawableResource by lazy {
      DrawableResource("drawable:baseline_person_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_person_24.xml", -1, -1),
      ))
    }

public val Res.drawable.bg_shape_dark: DrawableResource by lazy {
      DrawableResource("drawable:bg_shape_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_shape_dark.png", -1, -1),
      ))
    }

public val Res.drawable.briefcase: DrawableResource by lazy {
      DrawableResource("drawable:briefcase", setOf(
        ResourceItem(setOf(), "${MD}drawable/briefcase.xml", -1, -1),
      ))
    }

public val Res.drawable.briefcase2: DrawableResource by lazy {
      DrawableResource("drawable:briefcase2", setOf(
        ResourceItem(setOf(), "${MD}drawable/briefcase2.xml", -1, -1),
      ))
    }

public val Res.drawable.briefcase_unselect: DrawableResource by lazy {
      DrawableResource("drawable:briefcase_unselect", setOf(
        ResourceItem(setOf(), "${MD}drawable/briefcase_unselect.xml", -1, -1),
      ))
    }

public val Res.drawable.building: DrawableResource by lazy {
      DrawableResource("drawable:building", setOf(
        ResourceItem(setOf(), "${MD}drawable/building.xml", -1, -1),
      ))
    }

public val Res.drawable.calendar: DrawableResource by lazy {
      DrawableResource("drawable:calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar.xml", -1, -1),
      ))
    }

public val Res.drawable.calendar__1_: DrawableResource by lazy {
      DrawableResource("drawable:calendar__1_", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar__1_.xml", -1, -1),
      ))
    }

public val Res.drawable.calendar_unselect: DrawableResource by lazy {
      DrawableResource("drawable:calendar_unselect", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar_unselect.xml", -1, -1),
      ))
    }

public val Res.drawable.check_circle: DrawableResource by lazy {
      DrawableResource("drawable:check_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/check_circle.xml", -1, -1),
      ))
    }

public val Res.drawable.check_circle_1: DrawableResource by lazy {
      DrawableResource("drawable:check_circle_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/check_circle_1.xml", -1, -1),
      ))
    }

public val Res.drawable.check_mark: DrawableResource by lazy {
      DrawableResource("drawable:check_mark", setOf(
        ResourceItem(setOf(), "${MD}drawable/check_mark.xml", -1, -1),
      ))
    }

public val Res.drawable.chevron_left: DrawableResource by lazy {
      DrawableResource("drawable:chevron_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/chevron_left.xml", -1, -1),
      ))
    }

public val Res.drawable.chevron_right: DrawableResource by lazy {
      DrawableResource("drawable:chevron_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/chevron_right.xml", -1, -1),
      ))
    }

public val Res.drawable.city_icon: DrawableResource by lazy {
      DrawableResource("drawable:city_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/city_icon.xml", -1, -1),
      ))
    }

public val Res.drawable.city_icon_24: DrawableResource by lazy {
      DrawableResource("drawable:city_icon_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/city_icon_24.xml", -1, -1),
      ))
    }

public val Res.drawable.clipboard_small: DrawableResource by lazy {
      DrawableResource("drawable:clipboard_small", setOf(
        ResourceItem(setOf(), "${MD}drawable/clipboard_small.xml", -1, -1),
      ))
    }

public val Res.drawable.clock: DrawableResource by lazy {
      DrawableResource("drawable:clock", setOf(
        ResourceItem(setOf(), "${MD}drawable/clock.xml", -1, -1),
      ))
    }

public val Res.drawable.clock_small: DrawableResource by lazy {
      DrawableResource("drawable:clock_small", setOf(
        ResourceItem(setOf(), "${MD}drawable/clock_small.xml", -1, -1),
      ))
    }

public val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

public val Res.drawable.contact_ic: DrawableResource by lazy {
      DrawableResource("drawable:contact_ic", setOf(
        ResourceItem(setOf(), "${MD}drawable/contact_ic.xml", -1, -1),
      ))
    }

public val Res.drawable.contact_type: DrawableResource by lazy {
      DrawableResource("drawable:contact_type", setOf(
        ResourceItem(setOf(), "${MD}drawable/contact_type.xml", -1, -1),
      ))
    }

public val Res.drawable.contact_type_24: DrawableResource by lazy {
      DrawableResource("drawable:contact_type_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/contact_type_24.xml", -1, -1),
      ))
    }

public val Res.drawable.contacts_mail: DrawableResource by lazy {
      DrawableResource("drawable:contacts_mail", setOf(
        ResourceItem(setOf(), "${MD}drawable/contacts_mail.xml", -1, -1),
      ))
    }

public val Res.drawable.contacts_map_pin: DrawableResource by lazy {
      DrawableResource("drawable:contacts_map_pin", setOf(
        ResourceItem(setOf(), "${MD}drawable/contacts_map_pin.xml", -1, -1),
      ))
    }

public val Res.drawable.contacts_share: DrawableResource by lazy {
      DrawableResource("drawable:contacts_share", setOf(
        ResourceItem(setOf(), "${MD}drawable/contacts_share.xml", -1, -1),
      ))
    }

public val Res.drawable.country_icon: DrawableResource by lazy {
      DrawableResource("drawable:country_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/country_icon.xml", -1, -1),
      ))
    }

public val Res.drawable.country_icon_24: DrawableResource by lazy {
      DrawableResource("drawable:country_icon_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/country_icon_24.xml", -1, -1),
      ))
    }

public val Res.drawable.dahboard: DrawableResource by lazy {
      DrawableResource("drawable:dahboard", setOf(
        ResourceItem(setOf(), "${MD}drawable/dahboard.xml", -1, -1),
      ))
    }

public val Res.drawable.dahboard_unselect: DrawableResource by lazy {
      DrawableResource("drawable:dahboard_unselect", setOf(
        ResourceItem(setOf(), "${MD}drawable/dahboard_unselect.xml", -1, -1),
      ))
    }

public val Res.drawable.dropdown_arrow: DrawableResource by lazy {
      DrawableResource("drawable:dropdown_arrow", setOf(
        ResourceItem(setOf(), "${MD}drawable/dropdown_arrow.xml", -1, -1),
      ))
    }

public val Res.drawable.edit: DrawableResource by lazy {
      DrawableResource("drawable:edit", setOf(
        ResourceItem(setOf(), "${MD}drawable/edit.xml", -1, -1),
      ))
    }

public val Res.drawable.email_ic: DrawableResource by lazy {
      DrawableResource("drawable:email_ic", setOf(
        ResourceItem(setOf(), "${MD}drawable/email_ic.xml", -1, -1),
      ))
    }

public val Res.drawable.email_send_icon: DrawableResource by lazy {
      DrawableResource("drawable:email_send_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/email_send_icon.xml", -1, -1),
      ))
    }

public val Res.drawable.email_send_icon_24: DrawableResource by lazy {
      DrawableResource("drawable:email_send_icon_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/email_send_icon_24.xml", -1, -1),
      ))
    }

public val Res.drawable.employees: DrawableResource by lazy {
      DrawableResource("drawable:employees", setOf(
        ResourceItem(setOf(), "${MD}drawable/employees.xml", -1, -1),
      ))
    }

public val Res.drawable.employees_job_item: DrawableResource by lazy {
      DrawableResource("drawable:employees_job_item", setOf(
        ResourceItem(setOf(), "${MD}drawable/employees_job_item.xml", -1, -1),
      ))
    }

public val Res.drawable.employees_small: DrawableResource by lazy {
      DrawableResource("drawable:employees_small", setOf(
        ResourceItem(setOf(), "${MD}drawable/employees_small.xml", -1, -1),
      ))
    }

public val Res.drawable.employees_unselect: DrawableResource by lazy {
      DrawableResource("drawable:employees_unselect", setOf(
        ResourceItem(setOf(), "${MD}drawable/employees_unselect.xml", -1, -1),
      ))
    }

public val Res.drawable.fb: DrawableResource by lazy {
      DrawableResource("drawable:fb", setOf(
        ResourceItem(setOf(), "${MD}drawable/fb.xml", -1, -1),
      ))
    }

public val Res.drawable.file_text__1_: DrawableResource by lazy {
      DrawableResource("drawable:file_text__1_", setOf(
        ResourceItem(setOf(), "${MD}drawable/file_text__1_.xml", -1, -1),
      ))
    }

public val Res.drawable.filter_svgrepo_com_1: DrawableResource by lazy {
      DrawableResource("drawable:filter_svgrepo_com_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/filter_svgrepo_com_1.xml", -1, -1),
      ))
    }

public val Res.drawable.goodjob_logo: DrawableResource by lazy {
      DrawableResource("drawable:goodjob_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/goodjob_logo.xml", -1, -1),
      ))
    }

public val Res.drawable.google: DrawableResource by lazy {
      DrawableResource("drawable:google", setOf(
        ResourceItem(setOf(), "${MD}drawable/google.xml", -1, -1),
      ))
    }

public val Res.drawable.handshake_thin_svgrepo_com_1: DrawableResource by lazy {
      DrawableResource("drawable:handshake_thin_svgrepo_com_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/handshake_thin_svgrepo_com_1.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_actions_paper_check: DrawableResource by lazy {
      DrawableResource("drawable:ic_actions_paper_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_actions_paper_check.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_active_card: DrawableResource by lazy {
      DrawableResource("drawable:ic_active_card", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_active_card.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_back: DrawableResource by lazy {
      DrawableResource("drawable:ic_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_back.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_calendar: DrawableResource by lazy {
      DrawableResource("drawable:ic_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_calendar.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_check_white: DrawableResource by lazy {
      DrawableResource("drawable:ic_check_white", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_check_white.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_checkbox: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkbox", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkbox.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_leave: DrawableResource by lazy {
      DrawableResource("drawable:ic_leave", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_leave.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_logout: DrawableResource by lazy {
      DrawableResource("drawable:ic_logout", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_logout.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_logout_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_logout_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_logout_selected.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_mail: DrawableResource by lazy {
      DrawableResource("drawable:ic_mail", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_mail.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_map_pin: DrawableResource by lazy {
      DrawableResource("drawable:ic_map_pin", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_map_pin.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_members_card: DrawableResource by lazy {
      DrawableResource("drawable:ic_members_card", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_members_card.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_microsoft: DrawableResource by lazy {
      DrawableResource("drawable:ic_microsoft", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_microsoft.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_phone: DrawableResource by lazy {
      DrawableResource("drawable:ic_phone", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_phone.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_search: DrawableResource by lazy {
      DrawableResource("drawable:ic_search", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_search.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_settings: DrawableResource by lazy {
      DrawableResource("drawable:ic_settings", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_settings.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_settings_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_settings_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_settings_selected.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_skills: DrawableResource by lazy {
      DrawableResource("drawable:ic_skills", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_skills.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_teams_card: DrawableResource by lazy {
      DrawableResource("drawable:ic_teams_card", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_teams_card.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_user: DrawableResource by lazy {
      DrawableResource("drawable:ic_user", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_user.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_users: DrawableResource by lazy {
      DrawableResource("drawable:ic_users", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_users.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_work_scheduler: DrawableResource by lazy {
      DrawableResource("drawable:ic_work_scheduler", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_work_scheduler.xml", -1, -1),
      ))
    }

public val Res.drawable.icon: DrawableResource by lazy {
      DrawableResource("drawable:icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon.xml", -1, -1),
      ))
    }

public val Res.drawable.landing_img: DrawableResource by lazy {
      DrawableResource("drawable:landing_img", setOf(
        ResourceItem(setOf(), "${MD}drawable/landing_img.xml", -1, -1),
      ))
    }

public val Res.drawable.landing_img_dark: DrawableResource by lazy {
      DrawableResource("drawable:landing_img_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/landing_img_dark.xml", -1, -1),
      ))
    }

public val Res.drawable.layout: DrawableResource by lazy {
      DrawableResource("drawable:layout", setOf(
        ResourceItem(setOf(), "${MD}drawable/layout.xml", -1, -1),
      ))
    }

public val Res.drawable.location_plus: DrawableResource by lazy {
      DrawableResource("drawable:location_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/location_plus.xml", -1, -1),
      ))
    }

public val Res.drawable.log_out__1_: DrawableResource by lazy {
      DrawableResource("drawable:log_out__1_", setOf(
        ResourceItem(setOf(), "${MD}drawable/log_out__1_.xml", -1, -1),
      ))
    }

public val Res.drawable.logo: DrawableResource by lazy {
      DrawableResource("drawable:logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo.xml", -1, -1),
      ))
    }

public val Res.drawable.logo_dark_landing: DrawableResource by lazy {
      DrawableResource("drawable:logo_dark_landing", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_dark_landing.xml", -1, -1),
      ))
    }

public val Res.drawable.logo_good_job: DrawableResource by lazy {
      DrawableResource("drawable:logo_good_job", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_good_job.xml", -1, -1),
      ))
    }

public val Res.drawable.mail: DrawableResource by lazy {
      DrawableResource("drawable:mail", setOf(
        ResourceItem(setOf(), "${MD}drawable/mail.xml", -1, -1),
      ))
    }

public val Res.drawable.map: DrawableResource by lazy {
      DrawableResource("drawable:map", setOf(
        ResourceItem(setOf(), "${MD}drawable/map.xml", -1, -1),
      ))
    }

public val Res.drawable.map_job_item: DrawableResource by lazy {
      DrawableResource("drawable:map_job_item", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_job_item.xml", -1, -1),
      ))
    }

public val Res.drawable.map_pin: DrawableResource by lazy {
      DrawableResource("drawable:map_pin", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_pin.xml", -1, -1),
      ))
    }

public val Res.drawable.map_small: DrawableResource by lazy {
      DrawableResource("drawable:map_small", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_small.xml", -1, -1),
      ))
    }

public val Res.drawable.map_unselect: DrawableResource by lazy {
      DrawableResource("drawable:map_unselect", setOf(
        ResourceItem(setOf(), "${MD}drawable/map_unselect.xml", -1, -1),
      ))
    }

public val Res.drawable.notification: DrawableResource by lazy {
      DrawableResource("drawable:notification", setOf(
        ResourceItem(setOf(), "${MD}drawable/notification.xml", -1, -1),
      ))
    }

public val Res.drawable.notification_unselected: DrawableResource by lazy {
      DrawableResource("drawable:notification_unselected", setOf(
        ResourceItem(setOf(), "${MD}drawable/notification_unselected.xml", -1, -1),
      ))
    }

public val Res.drawable.onboarding_image1: DrawableResource by lazy {
      DrawableResource("drawable:onboarding_image1", setOf(
        ResourceItem(setOf(), "${MD}drawable/onboarding_image1.png", -1, -1),
      ))
    }

public val Res.drawable.onboarding_image2: DrawableResource by lazy {
      DrawableResource("drawable:onboarding_image2", setOf(
        ResourceItem(setOf(), "${MD}drawable/onboarding_image2.png", -1, -1),
      ))
    }

public val Res.drawable.pass_ic: DrawableResource by lazy {
      DrawableResource("drawable:pass_ic", setOf(
        ResourceItem(setOf(), "${MD}drawable/pass_ic.xml", -1, -1),
      ))
    }

public val Res.drawable.password_not_visible: DrawableResource by lazy {
      DrawableResource("drawable:password_not_visible", setOf(
        ResourceItem(setOf(), "${MD}drawable/password_not_visible.xml", -1, -1),
      ))
    }

public val Res.drawable.password_visible: DrawableResource by lazy {
      DrawableResource("drawable:password_visible", setOf(
        ResourceItem(setOf(), "${MD}drawable/password_visible.xml", -1, -1),
      ))
    }

public val Res.drawable.phone: DrawableResource by lazy {
      DrawableResource("drawable:phone", setOf(
        ResourceItem(setOf(), "${MD}drawable/phone.xml", -1, -1),
      ))
    }

public val Res.drawable.phone_1: DrawableResource by lazy {
      DrawableResource("drawable:phone_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/phone_1.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("admin_svgrepo_com_1", Res.drawable.admin_svgrepo_com_1)
  map.put("app_logo", Res.drawable.app_logo)
  map.put("apple", Res.drawable.apple)
  map.put("avatar_female", Res.drawable.avatar_female)
  map.put("avatar_male", Res.drawable.avatar_male)
  map.put("back_arrow", Res.drawable.back_arrow)
  map.put("background_shape", Res.drawable.background_shape)
  map.put("baseline_arrow_drop_down_24", Res.drawable.baseline_arrow_drop_down_24)
  map.put("baseline_file_present_24", Res.drawable.baseline_file_present_24)
  map.put("baseline_person_24", Res.drawable.baseline_person_24)
  map.put("bg_shape_dark", Res.drawable.bg_shape_dark)
  map.put("briefcase", Res.drawable.briefcase)
  map.put("briefcase2", Res.drawable.briefcase2)
  map.put("briefcase_unselect", Res.drawable.briefcase_unselect)
  map.put("building", Res.drawable.building)
  map.put("calendar", Res.drawable.calendar)
  map.put("calendar__1_", Res.drawable.calendar__1_)
  map.put("calendar_unselect", Res.drawable.calendar_unselect)
  map.put("check_circle", Res.drawable.check_circle)
  map.put("check_circle_1", Res.drawable.check_circle_1)
  map.put("check_mark", Res.drawable.check_mark)
  map.put("chevron_left", Res.drawable.chevron_left)
  map.put("chevron_right", Res.drawable.chevron_right)
  map.put("city_icon", Res.drawable.city_icon)
  map.put("city_icon_24", Res.drawable.city_icon_24)
  map.put("clipboard_small", Res.drawable.clipboard_small)
  map.put("clock", Res.drawable.clock)
  map.put("clock_small", Res.drawable.clock_small)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("contact_ic", Res.drawable.contact_ic)
  map.put("contact_type", Res.drawable.contact_type)
  map.put("contact_type_24", Res.drawable.contact_type_24)
  map.put("contacts_mail", Res.drawable.contacts_mail)
  map.put("contacts_map_pin", Res.drawable.contacts_map_pin)
  map.put("contacts_share", Res.drawable.contacts_share)
  map.put("country_icon", Res.drawable.country_icon)
  map.put("country_icon_24", Res.drawable.country_icon_24)
  map.put("dahboard", Res.drawable.dahboard)
  map.put("dahboard_unselect", Res.drawable.dahboard_unselect)
  map.put("dropdown_arrow", Res.drawable.dropdown_arrow)
  map.put("edit", Res.drawable.edit)
  map.put("email_ic", Res.drawable.email_ic)
  map.put("email_send_icon", Res.drawable.email_send_icon)
  map.put("email_send_icon_24", Res.drawable.email_send_icon_24)
  map.put("employees", Res.drawable.employees)
  map.put("employees_job_item", Res.drawable.employees_job_item)
  map.put("employees_small", Res.drawable.employees_small)
  map.put("employees_unselect", Res.drawable.employees_unselect)
  map.put("fb", Res.drawable.fb)
  map.put("file_text__1_", Res.drawable.file_text__1_)
  map.put("filter_svgrepo_com_1", Res.drawable.filter_svgrepo_com_1)
  map.put("goodjob_logo", Res.drawable.goodjob_logo)
  map.put("google", Res.drawable.google)
  map.put("handshake_thin_svgrepo_com_1", Res.drawable.handshake_thin_svgrepo_com_1)
  map.put("ic_actions_paper_check", Res.drawable.ic_actions_paper_check)
  map.put("ic_active_card", Res.drawable.ic_active_card)
  map.put("ic_back", Res.drawable.ic_back)
  map.put("ic_calendar", Res.drawable.ic_calendar)
  map.put("ic_check_white", Res.drawable.ic_check_white)
  map.put("ic_checkbox", Res.drawable.ic_checkbox)
  map.put("ic_leave", Res.drawable.ic_leave)
  map.put("ic_logout", Res.drawable.ic_logout)
  map.put("ic_logout_selected", Res.drawable.ic_logout_selected)
  map.put("ic_mail", Res.drawable.ic_mail)
  map.put("ic_map_pin", Res.drawable.ic_map_pin)
  map.put("ic_members_card", Res.drawable.ic_members_card)
  map.put("ic_microsoft", Res.drawable.ic_microsoft)
  map.put("ic_phone", Res.drawable.ic_phone)
  map.put("ic_search", Res.drawable.ic_search)
  map.put("ic_settings", Res.drawable.ic_settings)
  map.put("ic_settings_selected", Res.drawable.ic_settings_selected)
  map.put("ic_skills", Res.drawable.ic_skills)
  map.put("ic_teams_card", Res.drawable.ic_teams_card)
  map.put("ic_user", Res.drawable.ic_user)
  map.put("ic_users", Res.drawable.ic_users)
  map.put("ic_work_scheduler", Res.drawable.ic_work_scheduler)
  map.put("icon", Res.drawable.icon)
  map.put("landing_img", Res.drawable.landing_img)
  map.put("landing_img_dark", Res.drawable.landing_img_dark)
  map.put("layout", Res.drawable.layout)
  map.put("location_plus", Res.drawable.location_plus)
  map.put("log_out__1_", Res.drawable.log_out__1_)
  map.put("logo", Res.drawable.logo)
  map.put("logo_dark_landing", Res.drawable.logo_dark_landing)
  map.put("logo_good_job", Res.drawable.logo_good_job)
  map.put("mail", Res.drawable.mail)
  map.put("map", Res.drawable.map)
  map.put("map_job_item", Res.drawable.map_job_item)
  map.put("map_pin", Res.drawable.map_pin)
  map.put("map_small", Res.drawable.map_small)
  map.put("map_unselect", Res.drawable.map_unselect)
  map.put("notification", Res.drawable.notification)
  map.put("notification_unselected", Res.drawable.notification_unselected)
  map.put("onboarding_image1", Res.drawable.onboarding_image1)
  map.put("onboarding_image2", Res.drawable.onboarding_image2)
  map.put("pass_ic", Res.drawable.pass_ic)
  map.put("password_not_visible", Res.drawable.password_not_visible)
  map.put("password_visible", Res.drawable.password_visible)
  map.put("phone", Res.drawable.phone)
  map.put("phone_1", Res.drawable.phone_1)
}
